<section
    class="progress-bar"
    *ngIf="!isDownloadComplete || !networkStatusOnline"
    [ngClass]="{ hide: progress >= 100 }"
    (click)="networkStatusOnline && showDownloadInformation()"
>
    <mat-progress-bar *ngIf="networkStatusOnline" mode="buffer" [value]="progress" color="primary"></mat-progress-bar>
    <div class="no-network" *ngIf="!networkStatusOnline"></div>
    <div class="progress-bar__message">
        <mat-icon class="info-icon">info</mat-icon>
        <label *ngIf="networkStatusOnline"> {{ labels.downloadingGuides | translate }} {{ progress }}% </label>
        <label *ngIf="!networkStatusOnline"> {{ labels.conecctionError | translate }} </label>
    </div>
</section>
<section class="progress-bar" *ngIf="isDownloadComplete && updatingContentInformation.length" (click)="showUpdatingInformation()">
    <mat-progress-bar mode="buffer" value="0" color="primary"></mat-progress-bar>
    <div class="progress-bar__message">
        <mat-icon class="info-icon">info</mat-icon>
        <label> {{ updatingMessage() }} </label>
    </div>
</section>
